<nz-modal
  nzWidth="420px"
  [nzVisible]="visible()"
  [nzFooter]="null"
  [nzClosable]="false"
  [nzMaskClosable]="false"
  [nzKeyboard]="false"
  [nzBodyStyle]="modalBodyStyle"
  nzCentered
>
  <ng-container *nzModalContent>
    <section class="demo-login" aria-labelledby="demo-login-title">
      <div class="brand-lockup">
        <img src="assets/images/logo_v2.png" alt="Linkworld" />
        <span>Spotlight Demo</span>
      </div>

      <div class="login-heading">
        <span class="environment-label">演示环境</span>
        <h1 id="demo-login-title">访问验证</h1>
        <p>请输入演示账号和密码，验证通过后即可进入系统。</p>
      </div>

      <form nz-form [formGroup]="loginForm" (ngSubmit)="submit()" class="login-form">
        <nz-form-item>
          <nz-form-control nzErrorTip="请输入账号">
            <input
              nz-input
              formControlName="username"
              autocomplete="username"
              placeholder="账号"
              aria-label="账号"
            />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-control nzErrorTip="请输入密码">
            <input
              nz-input
              type="password"
              formControlName="password"
              autocomplete="current-password"
              placeholder="密码"
              aria-label="密码"
            />
          </nz-form-control>
        </nz-form-item>

        @if (errorMessage) {
          <div class="login-error" role="alert">
            <span class="error-mark" aria-hidden="true">!</span>
            <span>{{ errorMessage }}</span>
          </div>
        }

        <button
          nz-button
          nzType="primary"
          type="submit"
          class="login-submit"
          [nzLoading]="isSubmitting"
        >
          登录并进入
        </button>
      </form>

      <p class="security-note">
        <span class="security-dot" aria-hidden="true"></span>
        本验证仅用于演示环境访问控制
      </p>
    </section>
  </ng-container>
</nz-modal>
